import uiEn from '@sparklayer-io/spark-dash-ui/i18n/en';

import notifications from './notifications.json' with { type: 'json' };

/** The primitives' generic namespaces, plus the one this package owns. */
export default {
  ...uiEn,
  notifications,
};
